export function AppleIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M16.36 1.43c0 1.14-.42 2.2-1.12 2.99-.85.96-2.24 1.7-3.4 1.6-.14-1.1.4-2.27 1.06-3 .77-.86 2.13-1.5 3.46-1.59zM20.9 17.1c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.39 3.53-4.12 3.54-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.78-4.04-3.35C.32 15.9-.02 10.75 1.7 8.02c1.22-1.94 3.15-3.08 4.96-3.08 1.85 0 3.01 1.02 4.54 1.02 1.48 0 2.38-1.02 4.52-1.02 1.61 0 3.32.88 4.54 2.4-3.99 2.19-3.34 7.89.64 9.76z" />
    </svg>
  );
}

export function WindowsIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M0 3.45 9.75 2.1v9.4H0V3.45zM10.95 1.93 24 0v11.4H10.95V1.93zM0 12.6h9.75V22L0 20.65V12.6zM10.95 12.6H24V24l-13.05-1.8V12.6z" />
    </svg>
  );
}
